import axios from 'axios'

import store from '@/store'
import router from '@/router'
import appConfig from '@/config/app'

import { asyncLocalStorage } from '@/helpers/localStorage'
import UserHelper from '@/helpers/user'

const httpClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/api/${appConfig.apiVersion}`
})

function getToken () {
  return asyncLocalStorage.getItem('token')
}
function getRefreshToken () {
  return asyncLocalStorage.getItem('refreshToken')
}

// Set Headers On Page Load.
httpClient.defaults.headers.common['Accept'] = 'application/json'
httpClient.defaults.headers.common['Authorization'] = `Bearer ${typeof store !== 'undefined' ? store.getters.token : ''}` // TODO: Check why store is undefined

httpClient.interceptors.request.use(async (config) => {
  // Do something before request is sent
  const token = await getToken() // store.dispatch('loadToken')

  // Set Token Headers every API call to refresh the token
  config.headers.common['Authorization'] = `Bearer ${token}`

  return Promise.resolve(config)
}, async (error) => {
  // Do something with request error
  return Promise.reject(error)
})

httpClient.interceptors.response.use((response) => {
  // Do something with response data
  return response
}, async (error) => {
  // Do something with response error
  if (error.response.status === 401) {
    const refreshToken = await getRefreshToken()
    const formData = new FormData()
    formData.append('refresh_token', refreshToken)
    try {
      const httpClientRefreshToken = await axios.post(`${appConfig.apiBaseUrl}/api/v1/refresh-token`, formData)
      if (httpClientRefreshToken.status === 200) {
        const userData = new UserHelper(httpClientRefreshToken)
        asyncLocalStorage.setItem('token', userData.getAccessToken())
        asyncLocalStorage.setItem('refreshToken', userData.getRefreshToken())
        asyncLocalStorage.setItem('userInfo', JSON.stringify(userData.getUserData()))
        setTimeout(function () {
          location.reload()
        }, 1000)
      } else {
        throw new Error('Failed to refresh token')
      }
    } catch (refreshError) {
      if (refreshError.response) {
        console.error('Error response data:', refreshError.response.data)
        console.error('Error response status:', refreshError.response.status)
        console.error('Error response headers:', refreshError.response.headers)
        if (refreshError.response.status === 401) {
          store.dispatch('removeToken')
          router.push({ name: 'login' })
        }
      } else {
        store.dispatch('removeToken')
        router.push({ name: 'login' })
      }
    }
  }
  return Promise.reject(error)
})

export default httpClient
